module.exports = __webpack_public_path__ + "img/VATReport.b922f371.svg";